<template>
    <div class="d-flex align-items-center justify-content-between mb16">
        <Icon v-if="this.$store.state.resize.w <= 768" :name="'arrow-left'" class="pointer" @click="back" />
        <h4 class="text-black neue fw-medium mb-0 lh28 pr24 fsp20" :class="{ 'flex-grow-1 text-center': this.$store.state.resize.w <= 768 }">{{ this.$store.state.modal.content.title }}</h4>
        <Icon v-if="this.$store.state.resize.w > 768" :name="'close'" class="pointer" @click="this.close" />
    </div>
    <div class="bg-white rounded12" :class="{ 'p24': this.$store.state.resize.w > 768}">
        <div class="border-full bg-light-grey p24 rounded mb40">
            <div class="d-flex flex-row align-items-center mh-52 col-8 pb16 w-100 border-bottom mbp-16">
                <div v-if="content.curr.curr_logo" class="item-i round-border contain c40" :class="{'mrp-10': this.mobile, 'mr12': !this.mobile}" :style="`background-image: url('${content.curr.curr_logo}');`"></div>
                <div v-else :class="{'mr10': this.mobile, 'mr12': !this.mobile}">
                    <Icon name="default-curr" size="c40" />
                </div> 
                <div class="d-flex flex-column flex-grow-1">
                    <div class="d-flex align-items-center justify-content-between flex-grow-1">
                        <div class="flex-grow-1">
                            <div class='neue-roman d-flex align-items-center flex-row'>
                                <span v-if='content.curr.alias' :title='content.curr.alias' class="d-block text-black neue fw-medium text-truncate" :class="{ 'lhp20 fsp14': this.$store.state.resize.w <= 768 }">
                                    {{ this.$store.state.resize.w < 768 ? sbstring(content.curr.alias) : content.curr.alias }}
                                </span>
                                <span v-else class="text-black neue fw-medium text-truncate" :class="{ 'lhp20 fsp14': this.$store.state.resize.w <= 768, 'lhp24 fsp16': this.$store.state.resize.w > 768 }">{{ content.curr.keyt }}</span>
                            </div>
                            <span class='d-block primary-grey light col-10 text-truncate' :class="{'fsp12 lhp16': this.mobile, 'fsp14 lh20': !this.mobile}" :title='content.curr.name'>{{ content.curr.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <div class="primary-grey" :class="this.$store.state.resize.w <= 768 ?'fsp14' : 'fsp16'">{{ $t('components.service.modal.AssetDetails.3') }}</div>
                <div v-html="this.sumMask(content.curr.balance)" class="neue fw-medium text-black" />
            </div>
        </div>
        <p class="text-black neue-roman mb12">
            {{ this.$store.state.resize.w > 768 ? `${$t('components.service.modal.DeleteKeyt.1')}. ${$t('components.service.modal.DeleteKeyt.5')}` : `${$t('components.service.modal.DeleteKeyt.1')} “${content.curr.name}”` }}
        </p>
        <p v-if="this.$store.state.resize.w <= 768" class="text-black neue-roman mb12">
            {{ $t('components.service.modal.DeleteKeyt.5') }}
        </p>
        <p class="text-black neue-roman mb24">{{ $t('components.service.modal.DeleteKeyt.2') }}</p>
        <div class='d-flex mx-auto justify-content-center h48'>
            <Button :name="$t('components.service.modal.DeleteKeyt.3')" class='mr-1 flex-grow-1 fsp14' type='btn-outline-red' v-on:click='this.submit' />
            <Button :name="$t('components.service.modal.DeleteKeyt.4')" class="flex-grow-1 fsp14 primary-grey" type='btn-outline-grey' v-on:click='back' />
        </div>   
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import InputSimple from '../InputSimple.vue';
import Icon from '@/components/icons/Icon'

export default {
    components: {
        Button,
        InputSimple,
        Icon
    },
    props: {
        close: [Function],
    },
    data() {
        return {
            content: this.$store.state.modal.content.body,
        }
    },
    computed: {
        mobile () {
            return this.$store.state.isMobile;
        }
    },
    methods: {
        back() {
            this.$store.commit('MODAL', {
                action: true,
                type: 'AssetDetails',
                content: {
                    title: this.$t('views.Keyts.List.48'),
                    body: this.content,
                    width: 608
                },
            });
        },
        sumMask(sum, isSameSize) {
            if (!sum) {
                return;
            }
            let classList = `${this.mobile ? 'fsp20' : ''} text-black`
            if(isSameSize) {
                classList = 'fsp16'
            }
            let arr = sum.split('.');
            if (arr[1]) {
                return `<span  class='${classList}'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span><span class='neue fw-medium fsp12 primary-grey'>.${arr[1]}</span>`
            } else {
                return `<span  class='${classList}'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span>`
            }
        },
        sbstring(str) {
            if (this.$store.state.resize.w < 1024 && this.$store.state.resize.w > 768 && str.length > 7) {
                return this.$lib.getTokenString(str, 4);
            } else if(this.$store.state.resize.w <= 768) {
                return this.$lib.getTokenString(str, 14);
            } else if (this.$store.state.resize.w < 1200 && str.length > 12) {
                return this.$lib.getTokenString(str, 8);
            } else if (str.length > 30) {
                return this.$lib.getTokenString(str, 8);
            } 
            return this.$lib.getTokenString(str, 6);
        },
        submit() {
            if (this.content.curr.balance != '0.00') {
                return
            }
            this.$store.commit('DELETE_KEYT', {
                keyt: this.content.curr.keyt,
                balance: this.content.curr.balance,
                alias: this.content.curr.alias
            })
            this.$store.commit('MODAL', {
                action: false,
                type: false,
                content: false
            })
            this.$store.commit('DARK_WRAPPER', false);
        }
    },
}
</script>